// @flow
import styled from 'styled-components';

export const BlankPlayerImage = styled.img`
	height: 100%;
	margin: 0 .5em;
	opacity: .4;
`;

export default BlankPlayerImage;


// WEBPACK FOOTER //
// ./src/pages/league/team/blankPlayerImage.js